import { cssClass } from '../../style';

import { BrowserSupport } from '@tableau/browser-support';
import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '../../common/react/CommonStyles';

const cssPrefix = 'page-header';

export module HeaderStyles {

  // Currently duplicated in toaster.styl.
  export let TopBarHeight = 52;
  export let TopBarLineHeight = TopBarHeight + 'px';

  export let LetterSpacing = '0.08em';

  export let MenuPanelStyle: React.CSSProperties = {
    width: 240,
    height: 308,
    backgroundColor: CommonStyles.Colors.White,
    borderWidth: CommonStyles.Sizes.LineWidth,
    borderColor: CommonStyles.Colors.BorderColor,
    borderStyle: 'solid',
    fontSize: CommonStyles.Sizes.NormalFontSize,
    fontWeight: 'normal',
    lineHeight: CommonStyles.Sizes.LineHeight +'px',
    padding: CommonStyles.Sizes.SmallSpace,
    boxShadow: CommonStyles.Shadows.MenuShadow,
    position: 'relative' as 'relative', // Ensure absolutely positioned elements are relative to the parent menu panel
  };

  export let AlertsCountFontSize = '10px';

  // Colors

  export let HeaderBackgroundColor = 'rgb(42,87,117)';

  export let HeaderLinkSelectedColor = CommonStyles.Colors.White;
  export let HeaderLinkSelectedBackgroundColor = 'rgb(28,57,77)';
  export let HeaderLinkHoverBackgroundColor = 'rgb(35,74,99)';

  // Opacity

  export let HoverOpacity = 1.0;
  export let RestOpacity = 0.85;


  // Used for the FavoritesList (panel in the favorites dropdown menu)
  const listWidth = 228;
  const panelHMargins = CommonStyles.Sizes.DefaultSpace;
  const panelWidth = listWidth + (2 * panelHMargins);  // total 240
  const listHeight = 308;
  export const FavoritesList: React.CSSProperties = {
    maxHeight: listHeight,
    ...(BrowserSupport.IsIE() && { height: listHeight }),
    paddingLeft: '0px',
    paddingRight: '0px',
  };

  export const FavoritesPanel = cssClass(cssPrefix, 'favorites-panel', {
    paddingTop: `${CommonStyles.Sizes.DefaultSpace}px`,
    paddingBottom: `${CommonStyles.Sizes.DefaultSpace}px`,
    paddingLeft: `${panelHMargins}px`,
    paddingRight: `${panelHMargins}px`,
    width: panelWidth,
    minWidth: panelWidth
  });

  export const FavoritesSpinner = cssClass(cssPrefix, 'favorites-spinner', {
    marginTop: '48px',
    marginBottom: '48px',
    width: `${panelWidth}px`,
    textAlign: 'center'
  });

  export const FavoritesItemContainer = cssClass(cssPrefix, 'favorites-item-container', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    color: TabStyles!.Typography!.Color!.Primary,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    textDecoration: 'none',
    height: '24px',
    $nest: {
      '&:hover': {
        textDecoration: 'none',
        color: TabStyles!.Typography!.Color!.Primary,
      }
    }
  });

  export const FormattedMatch: React.CSSProperties = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '24px'
  };

  export const FavoritesIcon = cssClass(cssPrefix, 'favorites-icon', {
    marginRight: TabStyles.Spacing.DefaultSpace,
    height: 20
  });
}
